
import WebFont from 'webfontloader';
import { Host } from '../../Host';
import { AssetBundle, AssetBundleState } from '../../platform/assets/AssetBundle';
import './redacted/import.css';

export class LocalFontBundle implements AssetBundle {

    public state: AssetBundleState = 'waiting';

    public async load(): Promise<void> {
        this.state = 'loading';
        return new Promise((rs, rj) => {
            WebFont.load({
                custom: {
                    families: [
                        'redacted_scriptregular',
                    ],
                    urls: [
                        `${Host.cdnUrl}/app/index.css`
                    ],
                },
                active: () => rs(),
                inactive: () => {
                    console.error(new Error('LocalFontBundle: Some fonts failed to load.'));
                    rs();
                },
            });
        });
    }
}


